import React, { useEffect, useState } from "react";
import Sidemenu from "../base/sidemenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getRelation , registerUserWithFamily } from '../../services/userApiServicer';
import {formatMobilePhone} from "../../utils/phoneFormatter"


export default function UserFamily() {
  const navigate = useNavigate();
  const location = useLocation();
 console.log("가족등록 페이지 location.state:", location.state);
  const today = new Date().toISOString().split('T')[0];
 const userData = location.state?.userData;
  // 가족 정보 리스트 (초기 1명)
 const [familyList, setFamilyList] = useState(() => {
  // location.state가 없거나 familyList가 없으면 기본값 설정
  return location.state?.familyList || [{ name: "", phone: "", relation: "", birth: "" }];
});

useEffect(() => {
    if (location.state?.familyList) {
      setFamilyList(location.state.familyList);
    }
  }, [location.state]);
  
  // 관계 목록
  const [relList, setRelList] = useState([]);

  const token = localStorage.getItem("token");

  useEffect(() => {
    // 가족 관계 목록 API 호출
    const getRevList = async () => {
          try {
            const data = await getRelation(token);
            if (data.success === false) {
              alert(data.message);
              return;
            }
            setRelList(data.relation);
          } catch (error) {
            console.error("서비스 목록 불러오기 실패:", error);
          }
        };
    getRevList();
  }, [token]);

  // 가족 정보 추가
  const addFamily = () => {
    setFamilyList([...familyList, { name: "", phone: "", relation: "", birth: "" }]);
  };

  // 가족 정보 삭제
  const removeFamily = (index) => {
    const newList = [...familyList];
    newList.splice(index, 1);
    setFamilyList(newList);
  };

  // 입력값 변경
  const handleChange = (index, key, value) => {
    const updatedList = familyList.map((item, idx) =>
      idx === index ? { ...item, [key]: value } : item
    );
    setFamilyList(updatedList);
  };

  // 가족 정보 서버에 전송
  const handleSubmit = async () => {
    
    for (const fam of familyList) {
      if (!fam.name.trim()) {
        alert("가족 이름을 입력하세요.");
        return;
      }
      if (!fam.relation) {
        alert("가족과의 관계를 선택하세요.");
        return;
      }
    }
    const sendData = {
      ...userData,
      family: familyList,  // 가족 정보 배열
    };

    try {

      const response =await registerUserWithFamily(sendData, token);
      console.log("add ~~~~ ",response);
      if (response.success) {
          alert(response.message);
          navigate("/user"); 
        } else {
          alert(response.message);
        }

    } catch (error) {
      console.error("가족 정보 등록 실패:", error);
      alert("가족 정보 등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="flex">
      <Sidemenu />
      <div className="user">
        <h1>사용자 관리</h1>
        <div className="user_box">
          <h2 className="subpage_title">
            <span className="before">
              <span className="nametit">사용자 등록 - 가족정보</span>
            </span>
          </h2>
          <div className="user_writebox">
            {familyList.map((family, index) => (
              <div className="table02" key={index} style={{ marginBottom: "20px" }}>
                <table>
                  <caption>가족 정보 입력</caption>
                  <colgroup>
                    <col width="20%" />
                    <col width="80%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th scope="row">가족 이름</th>
                      <td>
                        <input
                          type="text"
                          placeholder="가족의 이름을 입력하세요."
                          value={family.name}
                          onChange={(e) => handleChange(index, "name", e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">연락처</th>
                      <td>
                        <input
                          type="text"
                          placeholder="가족의 연락처를 입력하세요."
                          value={family.phone}
                          onChange={(e) => handleChange(index, "phone", formatMobilePhone(e.target.value))}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">관계</th>
                      <td>
                        <select
                          value={family.relation}
                          onChange={(e) => handleChange(index, "relation", e.target.value)}
                        >
                          <option value="" disabled>
                            보호자와의 관계를 선택하세요.
                          </option>
                          {relList.map((rel) => (
                            <option key={rel.id} value={rel.id}>
                              {rel.name}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">생년월일</th>
                      <td>
                        <input
                          type="date"
                          value={family.birth}
                          max = {today}
                          onChange={(e) => handleChange(index, "birth", e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                {familyList.length > 1 && (
                  <div className="family_del">
                    <button type="button" onClick={() => removeFamily(index)}>
                      삭제
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="btn-group">
            <button className="btncolor02" onClick={() => navigate("/user/new", { state: { userData, familyList }})}>
              뒤로
            </button>
            <button type="button" className="btncolor03" onClick={addFamily}>
              가족 추가
            </button>
            <button className="btncolor01" onClick={handleSubmit}>
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
